module.exports = __webpack_public_path__ + "static/media/whispering-meadows.da665c32.pdf";